/**
 * Created by tschrader on 24.01.2017.
 */
export class SpreadMethod {
    public static PAD: string = "pad";
    public static REFLECT: string = "reflect";
    public static REPEAT: string = "repeat";
}

